import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';
import {
  Environment,
  Procedure,
  ProceduraHeaderIModel,
  ProcedureIModel,
  ProcedureTableModel,
  IProcedureRevisioniModel,
  TagCallerModel,
  ModelBool,
  IsError,
  IsErrorValues,
  ProcedureFormButtonsModel,
  ModelBoolNum,
  ProcCloneRevisPostModel,
  ModelNumNum,
} from '../../models/-index';

@Injectable()
export class ProcedureService extends CrudGenericsService<Procedure, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Procedure`);
    this.base = `${env.apiUrl}/api/Procedure/`;
  }
  // web
  GetProcedure_TableModel(): Observable<ProcedureTableModel[]> {
    const url = this.base + 'GetProcedure_TableModel';
    return this.http.get<ProcedureTableModel[]>(`${url}`);
  }
  // ionic
  GetCheckLists_ByTagOrId(model: TagCallerModel): Observable<ProcedureIModel> {
    const url = this.base + 'GetCheckLists_ByTagOrId';
    return this.http.post<ProcedureIModel>(`${url}`, model);
  }
  // ionic
  public GetProceduraAttiva(id: number): Observable<Procedure> {
    const url = this.base + 'GetProceduraAttiva?id=' + id;
    return this.http.get<Procedure>(`${url}`);
  }
  // ionic se ha un'altra pocedura memorizzata nelle ore di validita, è un  warning
  public Procedura_CheckIsUnique(id: number): Observable<IsError> {
    const url = this.base + 'Procedura_CheckIsUnique?id=' + id;
    return this.http.get<IsError>(`${url}`);
  }
  public GetCheckList_TargetHeader(id: number, target: string): Observable<ProceduraHeaderIModel> {
    const url = this.base + 'GetCheckList_TargetHeader?target_id=' + id + '&target=' + target;
    return this.http.get<ProceduraHeaderIModel>(`${url}`);
  }
  // web
  RevisioneOrClone(model: ProcCloneRevisPostModel): Observable<Procedure> {
    // passaggio di un modello invece di un id in post
    const url = this.base + 'RevisioneOrClone';
    return this.http.post<Procedure>(`${url}`, model);
  }
  // web
  public GetProcedureRevisioniModel_ByIdProc(id: number): Observable<IProcedureRevisioniModel[]> {
    const url = this.base + 'GetProcedureRevisioniModel_ByIdProc?id=' + id;
    return this.http.get<IProcedureRevisioniModel[]>(`${url}`);
  }

  // web
  /*
  public Procedura_CheckIsUniqueRevisione(id: number): Observable<ModelBool> {

    const url = this.base + 'Procedura_CheckIsUniqueRevisione?id=' + id;
    return this.http.get<ModelBool>(`${url}`);
  }*/
  // web wizard select revisiona procedura
  public Procedura_CheckPreventMultiRevisione(id: number): Observable<IsErrorValues> {
    const u = `${this.base}Procedura_CheckPreventMultiRevisione?id=${id}`;
    return this.http.get<IsErrorValues>(u);
  }

  // web form
  public Procedura_CambioStatoDisattivo(id: number, set_DtRevisione: boolean = false): Observable<IsError> {
    const u = `${this.base}Procedura_CambioStatoDisattivo?id=${id}&set_DtRevisione=${set_DtRevisione}`;
    return this.http.get<IsError>(u);
  }
  // web revisioni lista
  public Procedura_ShowAttiva(id: number): Observable<ModelBool> {
    const u = `${this.base}Procedura_ShowAttiva?id=${id}`;
    return this.http.get<ModelBool>(u);
  }
  // web form
  public UpdProc_AlertEseguita(id: number, val: boolean) {
    const model: ModelBoolNum = { Value: id, Bool: val };
    const u = `${this.base}UpdProc_AlertEseguita`;
    return this.http.post(u, model);
  }
  // web form
  public GetProceduraFormButtons(id: number): Observable<ProcedureFormButtonsModel> {
    const u = `${this.base}GetProceduraFormButtons?id= ${id}`;
    return this.http.get<ProcedureFormButtonsModel>(u);
  }
}
